module.exports = __webpack_public_path__ + "static/star-icon-d52ec6fe7557092e48de1945068a77e0.png";